/* eslint-disable import/no-cycle */
/* eslint-disable react/prop-types */
import React, { useRef, useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import './timelineComponent.scss';
import Timeline, { CustomMarker, 
                  DateHeader, SidebarHeader, TimelineHeaders, 
                  TimelineMarkers} from "react-calendar-timeline";
import moment from "moment";
import { getTimestampFromDate15Min, prettyNameFromType, randomNumberInRange } from '../../../utils/canvasUtils';
import sportRoomIcon from '../../atoms/customIcons/sportRoomIcon.svg'; 
import calendarIcon from '../../atoms/customIcons/calendarIcon.svg';
import staticImageIcon from '../../atoms/customIcons/staticImageIcon.svg';
import highlightedContentIcon from '../../atoms/customIcons/highlightedContentIcon.svg';
import externalVideoIcon from '../../atoms/customIcons/externalVideoIcon.svg';
import carouselIcon from '../../atoms/customIcons/carouselIcon.svg';
import spacesCarouselIcon from '../../atoms/customIcons/spacesCarouselIcon.svg';
import contentCategoryIcon from '../../atoms/customIcons/contentCategoryIcon.svg';
import interactableGraphicsIcon from '../../atoms/customIcons/interactableGraphicsIcon.svg';
import blockIcon from '../../atoms/customIcons/blockIcon.svg';
import arrowExpandedIcon from '../../atoms/customIcons/arrowExpandedIcon.svg';
import arrowContractedIcon from '../../atoms/customIcons/arrowContractedIcon.svg';
import 'react-calendar-timeline/lib/Timeline.css'
import TimelineContextMenu from './timelineContextMenu';
import swal from 'sweetalert';
/**
 * Canvas component 
 */
const TimelineDataComponent = (props) => {
  const {
    data,dateSelected,blockSelected,onUpdate,onSelectItem,onDeselectItem,onMoveAndSelectItem,onMoveTime,onDeleteBlock,onFillBlock,onMoveToEnd,minTime,maxTime,maxTimeDisplayTimeline

  } = props;
  const today =Date.now();
  const scrollViewRef = useRef();
  const [containers,setContainers] = useState([]);
  const [selected,setSelected] =useState(null);
  const [rightClickSelected,setRightClickSelected]=useState(null);
  const [blocks,setBlocks] =useState([]);
  const [blockCanvasX,setBlockCanvasX] =useState([]);
  const [defaultTimeStart,setDefaultTimeStart]= useState(moment(dateSelected));
  const [defaultTimeEnd,setDefaultTimeEnd] =useState( moment()
  .startOf("day")
  .add(7, "day")
  .toDate());
  const [targetSelected,setTargetSelected] =useState(null);

  const onScroll = (e) => {
    setRightClickSelected(null);
  }
  var keys = {
    groupIdKey: "id",
    groupTitleKey: "title",
    groupRightTitleKey: "rightTitle",
    itemIdKey: "id",
    itemTitleKey: "title",
    itemDivTitleKey: "title",
    itemGroupKey: "group",
    itemTimeStartKey: "start_time",
    itemTimeEndKey: "end_time",
    groupLabelKey: "title"
  };

  useEffect(() => {
    window.addEventListener('scroll', onScroll);
  },[]);

  useEffect(() => {
    if(data && data.data){
      if(Object.keys(data).length != 0){
        loadTimelineData(data.data);
      }
    }
  }, [data]);

  useEffect(()=>{
    setDefaultTimeStart(moment(dateSelected));
  },[dateSelected]);
  
  useEffect(()=>{
    if(blockSelected!=selected){
      setSelected(blockSelected);
    }
  },[blockSelected]);
  
  const drawIcon=(type)=>{
    if(type==null)
      return blockIcon;
    switch(type){
      case "sportRoom":
        return sportRoomIcon;
      case "highlightedContent":
        return highlightedContentIcon;
      case "externalContent":
        return externalVideoIcon;
      case "staticImage":
        return staticImageIcon;
      case "calendar":
        return calendarIcon;
      case "interactableGraphics":
        return interactableGraphicsIcon;
      case "contentCategory":
        return contentCategoryIcon;
      case "carousel":
        return carouselIcon;
      case "spacesCarousel":
        return spacesCarouselIcon;
    }
  }

  const loadTimelineData=(data)=>{
    let containerItems=[];
    let blockItems=[];
    let canvasModes=["Top","Middle","Bottom"];
    let minDate=minTime;
    let maxDate=maxTime;
    let maxDisplayDate=maxTimeDisplayTimeline;

    canvasModes.forEach((mode)=>{
      if(data && data[mode]){
        for(let i in data[mode]){
          if(data[mode][i].id){
            let groupId=data[mode][i].id;
            let containerTitle=mode+' '+data[mode][i].container;
            containerItems.push({id:"11"+groupId,title:containerTitle,root:true});
            containerItems.push({id:data[mode][i].id,title:containerTitle,root:false,parent:"11"+groupId});
            
            if(data[mode][i].blocks){
              for(let j in data[mode][i].blocks){
                let p=data[mode][i].blocks[j];
                let type=null;
                if(p.contents){
                  type=p.contents.type;
                }
                let icon=drawIcon(type);
                if(p.startEpoch<minDate){
                  p.startEpoch=minDate;
                }
                if(p.endEpoch>maxDisplayDate){
                  p.endEpoch=maxDisplayDate;
                }
                else if(p.endEpoch==0){
                  p.endEpoch=0;//maxDate=moment().add(10,'Y');
                }
                blockItems.push({id:p.UID,type:type,group:groupId,icon:icon,
                  title:prettyNameFromType(type),
                  start_time:p.startEpoch,
                  end_time:(p.endEpoch==0?maxDisplayDate:p.endEpoch),canvasMode:mode});
              }
            }
            blockItems.push({id:randomNumberInRange(10000,99999),type:"group",group:"11"+groupId,icon:"",
              title:containerTitle,
              start_time:minDate,
              end_time:maxDisplayDate});
          }
        }
      }
    });
    setContainers(containerItems);
    setBlocks(blockItems);
  }
  const labelFormat = {
    year: {
      long: 'YYYY',
      mediumLong: 'YYYY',
      medium: 'YYYY',
      short: 'YY'
    },
    month: {
      long: 'MMMM YYYY',
      mediumLong: 'MMMM',
      medium: 'MMMM',
      short: 'MM/YY'
    },
    week: {
      long: 'YYYY',
      mediumLong: 'w',
      medium: 'w',
      short: 'w'
    },
    day: {
      long: 'dddd, LL',
      mediumLong: 'dddd, LL',
      medium: 'dd D',
      short: 'D'
    },
    hour: {
      long: 'dddd, LL, HH:00',
      mediumLong: 'L, HH:00',
      medium: 'HH:00',
      short: 'HH'
    },
    minute: {
      long: 'HH:mm',
      mediumLong: 'HH:mm',
      medium: 'HH:mm',
      short: 'mm',
    },
    second: {
      "long": 'mm:ss',
      mediumLong: 'mm:ss',
      medium: 'mm:ss',
      "short": 'ss'
    }  
    }
  const handleItemDeselected=(el,el2)=>{
    setSelected([]);
    onDeselectItem();
  }
  const handleItemSelected=(el,el2,el3,el4)=>{
    setRightClickSelected(null);
    setSelected([]);
    onSelectItem(el);
  }
  const handleItemDoubleClick=(el,el2,timestamp)=>{
    onMoveTime(timestamp);
  }
  const handleContextMenu=(el,target,timestamp)=>{
    let fixDate=getTimestampFromDate15Min(null,timestamp);
    let d=moment.unix(fixDate/1000);
    setRightClickSelected({id:el,pos:{x:target.clientX,y:target.clientY},time:fixDate,date:d.format('HH:mm:ss')});
  }
  const handlerOnOutClick=()=>{
    setRightClickSelected(null);
  }
  const handlerOnContextMenuAction=(action,itemContext,target,item)=>{
    let found = blocks.find((item) => item.id ==target.id);
    if(!found)
      console.log("not found");
    else{
      switch(action){
        case "start":
          if(item.start_time>=minTime){
            scrollViewRef.current.scrollLeft=itemContext.dimensions.left-50;
            onMoveAndSelectItem(target.id);
          }else{
            let btns={};
            btns.ok=true;
            swal({
              title: "Date out of range  (-1month,6 months)!",
              content: "the block was create before the visible working timerange (-1month, 6months)",
              buttons: btns,
              dangerMode:true
            }).then((ok) => {
            });
          }
          break;
        case "end":
          if(item.end_time>maxTimeDisplayTimeline){
            let btns={};
            btns.ok=true;
            swal({
              title: "Date out of range  (-1month,6 months)!",
              content: "the end of the block is out of the timerange allowed (-1month,6 months)",
              buttons: btns,
              dangerMode:true
            }).then((ok) => {
            });
          }
          else{
            scrollViewRef.current.scrollLeft=itemContext.dimensions.left+itemContext.dimensions.width-200;
            onMoveToEnd(target.id);
          }
          break;
        case "delete":
            onDeleteBlock(target.id,target.time);
          break;
        case "fill":
            onFillBlock(target.id);
      }
    }
  }
  const handleOnClickGroup=(e,group)=>{
    toggleGroup(group,"on");
  }
  const itemRenderer = ({ item, timelineContext, itemContext, getItemProps, getResizeProps }) => {
    itemContext.selected=false;
    const isSelected=itemContext.selected || item.id==selected;
    let visibilityLevel=0;
    if(itemContext.dimensions.width>200){
      visibilityLevel=3;//all elements visible
    }else if(itemContext.dimensions.width>35){
      visibilityLevel=2; //only icon
    }else
      visibilityLevel=1; // none visible

    if(item.type=="group"){
      return(
       <div  {...getItemProps({className:"timeline-item timeline-item--type-"+item.type})} onClick={(e)=>handleOnClickGroup(e,item.group)}>
        <div id={item.id}>
            <div className="rct-item-content">
              <div>
                {visibilityLevel>=2 && <b>{item.title}</b>}
                {visibilityLevel>=3 &&<span> Show contents</span>}
                </div>
            </div>
          </div>
        </div> 
      );
    }else{
      return (
        <div  {...getItemProps({className:"timeline-item timeline-item--type-"+item.type +(isSelected?" selected":"")})}>
          <div id={item.id}>
            <div className="rct-item-content">
              <div>
                {visibilityLevel>=2 && <img className="timeline-content-image" src={item.icon}/>}
                {visibilityLevel>=3 &&<b>{item.title}</b>}
                </div>
            </div>
            {rightClickSelected && <TimelineContextMenu
                target={rightClickSelected}
                targetSelected={targetSelected}
                item={item}
                itemContext={itemContext}
                options={[{id:'start',title:'Go to content start'},{id:'end',title:'Go to content end'}, {id:'fill',title:'Fill block'},{id:'delete',title:'Delete content'}]}
                classes={{
                  listWrapper: 'customContextmenuArea1ListWrapper',
                  listItem: 'timelineListItem'
                }}
                onSendAction={handlerOnContextMenuAction}
                onOutClick={handlerOnOutClick}
              />}
          </div>
        </div>
      );
    }
  };
  const defaultTimeRange = defaultTimeEnd - defaultTimeStart;

  const handleTimeChange = (visibleTimeStart, visibleTimeEnd, updateScrollCanvas) => {
    if (visibleTimeStart < minTime && visibleTimeEnd > maxTimeDisplayTimeline) {
      updateScrollCanvas(minTime, maxTimeDisplayTimeline);
    } else if (visibleTimeStart < minTime) {
      updateScrollCanvas(
        minTime,
        minTime + (visibleTimeEnd - visibleTimeStart)
      );
    } else if (visibleTimeEnd > maxTimeDisplayTimeline) {
      updateScrollCanvas(
        maxTimeDisplayTimeline - (visibleTimeEnd - visibleTimeStart),
        maxTimeDisplayTimeline
      );
    } else {
      updateScrollCanvas(visibleTimeStart, visibleTimeEnd);
    }
  };
  // const handleScrollRef=(el)=>{
  //   console.log("scroll",el);
  // }
  const [openGroups,setOpenGroups] =useState([]);
  
  const toggleGroup = (id,mode) => {
    if(mode=="on"){
      setOpenGroups({
        ...openGroups,
        [id]: !openGroups[id]
      });
    }else{
      const newOpenGroups = Object.keys(openGroups).reduce((object, key) => {
        if (key !== "11"+id) {
          object[key] = openGroups[key]
        }
        return object
      }, {});
      setOpenGroups(newOpenGroups);
    }
  }

  const newGroups = containers
      .filter(g => {
        return (g.root && !(g.id in openGroups))  || (g.root==false && openGroups[g.parent]);
      })
      .map(group => {
        return Object.assign({}, group, {
          title: group.root ? (
            <div className="timeline-group" onClick={() => toggleGroup(parseInt(group.id),"on")} style={{ cursor: "pointer" }}>
              {openGroups[parseInt(group.id)]? <img src={arrowContractedIcon}/> : <img  width="16" src={arrowExpandedIcon} />} {group.title}
            </div>
          ) : (
            <div className="timeline-group" onClick={() => toggleGroup(parseInt(group.id),"off")} style={{ cursor: "pointer" }}>
              {openGroups[parseInt(group.id)] ? <img src={arrowExpandedIcon} />: <img  width="16" src={arrowContractedIcon}/>} {group.title}
            </div>
          )
        });
      });
  return (
    <div className="timelineDataComponent">
      {containers.length>0 && blocks && <Timeline
        groups={newGroups}
        items={blocks}
        keys={keys}
        itemsSorted
        itemTouchSendsClick={false}
        stackItems
        itemHeightRatio={0.80}
        minZoom={60*60*15*60}
        maxZoom={defaultTimeRange}
        canMove={false}
        canResize={false}
        defaultTimeStart={defaultTimeStart}
        defaultTimeEnd={defaultTimeEnd}
        selected={[selected]}
        onCanvasClick={handleItemDeselected}
        onItemSelect={handleItemSelected}
        onSelectItem={handleItemSelected}
        onItemDeselect={handleItemDeselected}
        onItemDoubleClick={handleItemDoubleClick}
        onItemContextMenu={handleContextMenu}
        onTimeChange={handleTimeChange}
        itemRenderer={itemRenderer}
        scrollRef={ref=>scrollViewRef.current=ref} 
        lineHeight={35}
        timeSteps={
          {
          minute: 15,
          hour: 1,
          day: 1,
          month: 1,
          year: 1}
        }
      >
        <TimelineMarkers>
          <CustomMarker date={dateSelected}>
            {({ styles, date }) =>{
              styles.zIndex=100;
              return ( <div className={'selected-marker'} style={styles} ><div className='selected-tag'></div></div>);
            }
          }
          </CustomMarker>
          <CustomMarker date={today}>
            {({ styles }) =>{
              styles.zIndex=100;
              return ( <div className={'today-marker'} style={styles} ><div className='today-tag'>Now</div></div>);
            }
            }
          </CustomMarker>
        </TimelineMarkers>
        <TimelineHeaders className="sticky">
          <SidebarHeader>
            {({ getRootProps }) => {
              return <div className="timeline-containers-title" {...getRootProps()}></div>;
            }}
          </SidebarHeader>
          <DateHeader className='timelineHeader1' unit="primaryHeader"/>
          <DateHeader className='timelineHeader2'/>
        </TimelineHeaders>
      </Timeline>}
    </div>);
};

TimelineDataComponent.propTypes = {
     /**
      * Function to propagate to parent to send to server the object
      */
     value:PropTypes.object
};

TimelineDataComponent.defaultProps = {
    value:{},
    data:null
};
export default TimelineDataComponent;
